import api from './api';
import logger from './logger';

const CACHE_TTL_MS = 60 * 1000;

let cachedLocation = null;
let cachedData = undefined;
let cachedAt = 0;
let inFlightPromise = null;

const isFresh = (location) =>
  cachedLocation === location &&
  cachedData !== undefined &&
  Date.now() - cachedAt < CACHE_TTL_MS;

export const clearWebsiteTrainingPendingCache = () => {
  cachedLocation = null;
  cachedData = undefined;
  cachedAt = 0;
};

export const fetchWebsiteTrainingPending = async (location, { force = false } = {}) => {
  if (!location) {
    return null;
  }

  if (!force && isFresh(location)) {
    return cachedData;
  }

  if (!force && inFlightPromise) {
    return inFlightPromise;
  }

  inFlightPromise = api
    .get(`/api/trainings/website/pending?location=${encodeURIComponent(location)}`)
    .then((res) => {
      cachedLocation = location;
      cachedData = res.data ?? null;
      cachedAt = Date.now();
      return cachedData;
    })
    .catch((err) => {
      logger.error('Error fetching website training pending state:', err);
      throw err;
    })
    .finally(() => {
      inFlightPromise = null;
    });

  return inFlightPromise;
};
